import { FunctionComponent, useCallback } from 'react';
import { CustomButton } from '@foxtrotplatform/developer-platform-common-ui-component-lib';

import { useSignUp } from '../../../common/hooks/useSignUp';

export const ClearStateBackButton: FunctionComponent = () => {
  const { clearStateStorage } = useSignUp();
  const onClick = useCallback(() => {
    clearStateStorage();
  }, [clearStateStorage]);
  return (
    <CustomButton
      actionType="primary"
      onClick={onClick}
      testId="waitlist-back-btn"
      className="px-6"
    >
      <span className="font-bold">Go Back</span>
    </CustomButton>
  );
};
